import {
  userListReducer,
  inviteUserReducer,
  userByIdReducer,
  currentUserReducer
} from './reducers';

export default {
  userList: userListReducer,
  userInvite: inviteUserReducer,
  user: userByIdReducer,
  currentUser: currentUserReducer
};
